
(function () {
    'use strict';

    angular.module('thankview.auth', [])
        .directive('tvAuthForm', ['$interval', function ($interval) {
            return {
                restrict: 'A',
                link: function (scope, element) {
                    var AUTOFILL_INTERVAL_MS = 500;

                    scope.user = {};

                    scope.init = function () {
                        scope.setFormDataValues();
                        scope.pollInputs();
                    };

                    /*
                    * When form submissions fail, let's set the scope variables
                    * to the input values of what was previously submitted
                    */
                    scope.setFormDataValues = function () {
                        angular.forEach(element.find('input'), function (input) {
                            input = angular.element(input);

                            if (input.attr('data-value')) {
                                scope.user[input.attr('name')] = input.attr('data-value');
                            }
                        });
                    };

                    /*
                    * Poll any text, email, or password input fields
                    * in our forms.
                    */
                    scope.pollInputs = function () {
                        var types = ['text', 'email', 'password'];

                        angular.forEach(element.find('input'), function (input) {
                            input = angular.element(input);

                            if (types.indexOf(input.attr('type')) !== -1) {
                                var interval = $interval(function () {
                                    scope.watchInput(input, interval);
                                }, AUTOFILL_INTERVAL_MS);
                            }
                        });
                    };

                    /*
                    * Watch input for any change of it's value.
                    * If the value doesn't match our scope variable,
                    * then our browser autofilled.
                    */
                    scope.watchInput = function (input, interval) {
                        var userField = input.attr('name');

                        // Cancel polling if there is input from the user
                        if (scope.user[userField]) {
                            $interval.cancel(interval);
                            return;
                        }

                        // Check if there is autofill from the browser
                        if (input.val() !== '' && input.val() !== scope.user[userField]) {
                            scope.user[userField] = input.val();
                            $interval.cancel(interval);
                        }
                    };

                    scope.init();
                },
            };
        }]);
}());
